import { ImageList } from "../twig/components/ImageList";
import { ImageViewer } from "../twig/components/ImageViewer";
(new ImageList()).init();
(new ImageViewer()).init();
